/**
 * This composable fixes the issue where the page does not auto-scroll to an anchor tag after a client-side redirect.
 */
export const useRouteAnchorScroll = () => {
    const route = useRoute();
    watch(
        () => route.hash,
        async (hash) => {
            if (hash) {
                await nextTick();
                setTimeout(() => {
                    const el = document.querySelector(hash)
                    if (el) {
                        el.scrollIntoView({ behavior: 'smooth' })
                    }
                }, 100)
            }
        },
        { immediate: true }
    )
}
